
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]/sourcemap/[sourceId]",
      function () {
        return require("private-next-pages/[id]/sourcemap/[sourceId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[id]/sourcemap/[sourceId]"])
      });
    }
  